import { render, staticRenderFns } from "./op-detail.vue?vue&type=template&id=e2759462&scoped=true"
import script from "./op-detail.vue?vue&type=script&lang=js"
export * from "./op-detail.vue?vue&type=script&lang=js"
import style0 from "./op-detail.vue?vue&type=style&index=0&id=e2759462&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2759462",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2759462')) {
      api.createRecord('e2759462', component.options)
    } else {
      api.reload('e2759462', component.options)
    }
    module.hot.accept("./op-detail.vue?vue&type=template&id=e2759462&scoped=true", function () {
      api.rerender('e2759462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliancecso/contractManager/dialog/op-detail.vue"
export default component.exports